import atlasApi from '..'
//eslint-disable-next-line
import { AxiosResponse } from 'axios'

const inventoryPrefix = '/brands/v2/inventories'

/**
 * Retrieve user products from the API.
 *
 * @param {{
 *   hasStock?: boolean | undefined,
 *   groupBy?: 'order' | 'category' | 'stock' | 'date_added' | undefined,
 *   sortBy: 'ascending' | 'descending',
 *   q?: string,
 *   page?: number,
 *   perPage?: number,
 *   clientId?: string
 * }} params - Parameters for the API request.
 * @returns {Promise<AxiosResponse<any>>} Axios response.
 */
const getUserProducts = async (params) => {
  return atlasApi.get(inventoryPrefix, { params })
}

export { getUserProducts }
